module.exports = __webpack_public_path__ + "img/dengta.faf845b7.png";